<form [formGroup]="dependentsForm" (ngSubmit)="onSubmitForm()">
  <div formArrayName="dependent">
    @for (dependents of addDependent().controls; track dependents; let i = $index) {
      <div [formGroupName]="i">
        @if (dependents.get('action').value != 'delete') {
          <div [id]="'dep-container' + i">
            <div class="fwc-row fwc-row-bm">
              <div class="fwc-col-12">
                <h3 #depHeader>Dependent</h3>
              </div>
            </div>
            <div class="fwc-row fwc-row-bm">
              <div class="fwc-col-3 sm-12">
                <div class="fwc-select-list">
                  <label for="type">Type</label>
                  <select name="type" id="type" formControlName="type">
                    <option value="" selected>Select a type</option>
                    <option value="Spouse">Spouse</option>
                    <option value="Child">Child</option>
                    <option value="Domestic Partner">Domestic Partner</option>
                  </select>
                  @if (dependents.get('type').hasError('required') && formSubmitted) {
                    <span role="alert"
                    class="fwc-inline-icon fwc-icon-delete">Please select a valid type</span>
                  }
                </div>
              </div>
              <div class="fwc-col-3 sm-12 fwc-input">
                <label for="firstName">First Name</label>
                <div class="sae-masked-input">
                  <input name="firstName" id="firstName" formControlName="firstName" type="text"
                    pattern="^[A-Za-z- ']+$" maxlength="20" />
                  @if (dependents.get('firstName').errors && formSubmitted) {
                    <span role="alert"
                    class="fwc-inline-icon fwc-icon-delete">Please enter a valid first name</span>
                  }
                </div>
              </div>
              <div class="fwc-col-3 sm-12 fwc-input">
                <label for="middleInitial">Middle Initial <span class="optionalFeild-design">
                Optional</span>
              </label>
              <div class="sae-masked-input">
                <input name="middleInitial" id="middleInitial" formControlName="middleInitial" type="text"
                  pattern="^[A-Za-z]+$" maxlength="1" />
                @if ( dependents.get('middleInitial').errors && formSubmitted) {
                  <span role="alert"
                  class="fwc-inline-icon fwc-icon-delete">Please enter a valid middle initial</span>
                }
              </div>
            </div>
            <div class="fwc-col-3 sm-12 fwc-input">
              <label for="lastName">Last Name</label>
              <div class="sae-masked-input">
                <input name="lastName" id="lastName" formControlName="lastName" type="text"
                  pattern="^[A-Za-z- ']+$" maxlength="25" />
                @if (dependents.get('lastName').errors && formSubmitted) {
                  <span role="alert"
                  class="fwc-inline-icon fwc-icon-delete">Please enter a valid last name</span>
                }
              </div>
            </div>
          </div>
          <div class="fwc-row fwc-row-bm">
            <div class="fwc-col-3 sm-12">
              <div class="fwc-select-list">
                <label for="gender">Gender</label>
                <select name="gender" id="gender" formControlName="gender">
                  <option value="" selected>Select a gender</option>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                  <option value="U">Unknown</option>
                </select>
                @if (dependents.get('gender').errors && formSubmitted) {
                  <span role="alert"
                  class="fwc-inline-icon fwc-icon-delete">Please select a valid gender</span>
                }
              </div>
            </div>
            <div class="fwc-col-3 sm-12 fwc-input">
              <label for="identityAs">Identify As <span class="optionalFeild-design">
              Optional</span></label>
              <div class="sae-masked-input">
                <input name="identityAs" id="identityAs" formControlName="identityAs" type="text"
                  pattern="^[A-Za-z]+$" maxlength="255" />
                @if (dependents.get('identityAs').errors && formSubmitted) {
                  <span role="alert"
                  class="fwc-inline-icon fwc-icon-delete">Please enter a valid identify as</span>
                }
              </div>
            </div>
            <div class="fwc-col-3 sm-12">
              <fwc-date-picker id="{{'dob-input'}}" attr.input-label="{{'Date of Birth'}}"
                [attr.show-date]="addDependentFormData?.dependent[i] ? showStartDate : !showStartDate "
                [attr.start-date]="addDependentFormData?.dependent[i] && addDependentFormData.dependent[i].DOB ? addDependentFormData.dependent[i].DOB : ''  "
                attr.date-range="{{dateRange}}" [invalid]="dependents.get('DOB').errors && formSubmitted"
                (fwc-date-picker-blur)="blurEvent($event, i)"
                (fwc-date-picker-selected)="updateDob($event, i)">
              </fwc-date-picker>
              <div class="fwc-input">
                <input type="hidden" id="DOB" name="DOB" formControlName="DOB" />
                @if ((dependents.get('DOB').errors || ageError[i] == true ) && formSubmitted  ) {
                  <span role="alert"
                  class="fwc-inline-icon fwc-icon-delete">Please enter a valid date of birth</span>
                }
              </div>
            </div>
          </div>
          <div class="fwc-row fwc-row-bm">
            <div class="fwc-col-4 sm-12 fwc-input">
              <label for="altEmail">Email Address <span class="optionalFeild-design">
              Optional</span></label>
              <div class="sae-masked-input">
                <input name="altEmail" id="altEmail" formControlName="email" type="text"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" maxlength="255" />
                @if (dependents.get('email').errors && formSubmitted) {
                  <span role="alert"
                  class="fwc-inline-icon fwc-icon-delete">Please enter a valid email address</span>
                }
              </div>
            </div>
            <div class="fwc-col-3 sm-12 fwc-input">
              <label for="altPhone">Phone Number <span class="optionalFeild-design">
              Optional</span></label>
              <div class="sae-masked-input">
                <input name="altPhone" id="altPhone" formControlName="phone" type="text" maxlength="16"
                  pattern="[0-9-]+" />
                @if (dependents.get('phone').errors && formSubmitted) {
                  <span role="alert"
                  class="fwc-inline-icon fwc-icon-delete">Please enter a valid phone number</span>
                }
              </div>
            </div>
          </div>
          <div class="fwc-row fwc-row-bm top-pad-xs">
            <div class="fwc-flex-column">
              <button class="fwc-btn fwc-btn-secondary" type="button" (click)="removeQuantity(i)">Remove
              dependent</button>
            </div>
          </div>
          <div class="fwc-row">
            <div class="fwc-col-12 fwc-divider">
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (countArray() >= 1) {
    <button class="fwc-btn fwc-btn-secondary top-xs" type="button"
      (click)="addQuantity()">Add
    another dependent</button>
  }
  @if (this.dependentsForm.value.dependent.length === 0 ||countArray() === 0 ) {
    <button class="fwc-btn fwc-btn-secondary top-xs" type="button"
      (click)="addQuantity()">Add
    a dependent</button>
  }

</div>
</form>
